export default "/images/7916d9fe361da6bb388bf5e155cb9126.avif";